import React, { useState } from 'react';
import { useBlogPosts } from '../hooks/useBlogPosts';
import { useBreadcrumb } from '../contexts/BreadcrumbContext';
import Breadcrumb from '../components/Breadcrumb';
import BlogPostCard from '../components/blog/BlogPostCard';
import { Loader2, Search } from 'lucide-react';

export default function Blog() {
  const { posts, loading, error } = useBlogPosts();
  const { setItems } = useBreadcrumb();
  const [searchQuery, setSearchQuery] = useState('');

  React.useEffect(() => {
    setItems([
      { label: 'Home', path: '/' },
      { label: 'Articles', path: '/blog' }
    ]);
  }, [setItems]);

  // Filter posts based on search query
  const filteredPosts = posts.filter(post => {
    const searchLower = searchQuery.toLowerCase();
    return (
      post.title.toLowerCase().includes(searchLower) ||
      post.excerpt.toLowerCase().includes(searchLower) ||
      post.content.toLowerCase().includes(searchLower)
    );
  });


  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb />
        
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-8">
          <h1 className="text-3xl font-bold">Articles</h1>
          
          {/* Search Input */}
          <div className="relative w-full sm:w-64">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search articles..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
            />
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
          </div>
        ) : error ? (
          <div className="text-red-600">{error}</div>
        ) : filteredPosts.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600">
              {searchQuery 
                ? "No articles found matching your search." 
                : "No articles available."}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map(post => (
              <BlogPostCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}